import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Button } from '@mui/material'
import { styled } from '@mui/material/styles'

import messages from './GotIt.messages'
export interface IOwnProps {
  className?: string
  orderId:    number
  itemId?:    number
  reason?:    string
}

export interface IStateProps {
}

export interface IDispatchProps {
  requestGotIt: (orderId: number, itemId?: number) => void
}

export type IProps = IOwnProps & IStateProps & IDispatchProps;

const HelpText = styled('span')(({ theme }) => ({
  color: theme.palette.blackColor.main,
  fontWeight: '400!important',
}))

const GotIt:React.FC<IProps> = (props) => {
  const {
    orderId,
    itemId,
    requestGotIt,
    className,
    reason,
  } = props

  const intl = useIntl()

  return (
    <Button
      className={className}
      onClick={() => requestGotIt(orderId, itemId)}
      aria-label={intl.formatMessage({...messages.text})}
    >
      {
        reason && <HelpText>{reason}</HelpText>
      }
      <FormattedMessage {...messages.text} />
    </Button>
  )
}

export default styled(GotIt)(({ theme }) => ({
  display: 'inline-block',
  color: theme.palette.warning.main,
  fontSize: 13,
  fontWeight: 400,
  textAlign: 'left',
  textDecoration: 'none',
  border: '1px solid #d7d7d7',
  borderRadius: 0,
  position: 'relative',
  minWidth: 52,
  padding: '2px 7px',
  flexShrink: 0,
  marginLeft: theme.spacing(3),
  backgroundColor: '#f2f2f2',
  '&::after': {
    content: '""',
    width: 13,
    height: 13,
    position: 'absolute',
    top: 7,
    left: -8,
    border: '1px solid #d7d7d7',
    borderRight: 'none',
    borderTop: 'none',
    background: 'linear-gradient(45deg, #f2f2f2 0%, #f2f2f2 50%, transparent 50%)',
    transform: 'scale(1.2, 0.6) rotate(45deg)',
    transition: 'background 250ms cubic-bezier(0.4, 0, 0.2, 1) 250ms',
  },
  '&:hover': {
    backgroundColor: '#fdfaec',
    '&::after': {
      background: 'linear-gradient(45deg, #fdfaec 0%, #fdfaec 50%, transparent 50%)',
    },
  },
}))
